<template>
    <div>
        <div v-if="requestMade">
            <div class="skinny row">
                <div class="col-sm-12">
                    <div v-if="dataResponse.projects.length > 1" class="vx-col w-full mb-3">
                        <vs-select class="w-full mb-2"
                            label="Selecciona un proyecto para ver sus eventos." 
                            v-model.lazy="selectedProjectEventHistory"
                            name="selectedProjectEventHistory"
                            color="dark"
                            placeholder="Seleccione una opción" >
                            <vs-select-item :key="index" :value="item.project_id" :text="item.alias" v-for="(item,index) in dataResponse.projects" class="w-full" />
                        </vs-select>
                    </div>
                    <div>
                        <vs-table
                            :sst="true"
                            ref="table"
                            stripe
                            :max-items="5"
                            :data="allEventsProjectHistory"
                            noDataText="No hay datos disponibles"
                        >
                        <div slot="header" class="mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
                        <div class="pager" v-if="allEventsProjectHistory.length > 0">
                            <div class="flex flex-wrap">
                            <vs-select
                                label="Página"
                                @input="pager"
                                v-model.lazy="numberSearchPage"
                                name="numberSearchPage"
                            >
                                <vs-select-item
                                :key="index+1"
                                :value="index+1"
                                :text="index+1"
                                v-for="(value, index) in allDataHistory.last_page"
                                class="w-full"
                                />
                            </vs-select>
                            </div>
                        </div>
                        <label class="bold mt-4" style="text-decoration: underline;">Estos eventos son visibles por los inversionistas</label>
                        <!-- ITEMS PER PAGE -->
                        <div
                            v-if="totalRecords > 0"
                            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                        >
                            <span class="mr-2">{{ from }} - {{ to }} de {{ totalRecords }}</span>
                        </div>
                        </div>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                    <vs-td><small><strong>{{compactDateTimeFormat(tr.created_at)}}</strong> - <strong>{{tr.title}}</strong><br>
                                    {{tr.event}}</small></vs-td>
                                    <vs-td>
                                        <vs-button
                                        radius
                                        :disabled="!tr.can_be_deleted"
                                        color="danger"
                                        type="filled"
                                        icon-pack="feather"
                                        icon="icon-trash"
                                        @click="confirmDeleteProjectEvent(tr.id)"
                                        ></vs-button>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import dateHelper from "@mixins/dateHelper";
    import formatHelper from "@mixins/formatHelper";
    import { es } from "vuejs-datepicker/dist/locale";

    export default {
        name: "CashingProjectEventLog",
        props:['clientId'],
        mixins: [formatHelper,dateHelper],
        async mounted(){
            await this.getEvents();
        },
        data(){
            return {
                es: es,
                loading:false,
                eventsToShow:[],
                numberSearchPage: 1,
                projectsSelected:[],
                selectedProject: 0,
                selectedProjectEventHistory: 0,
                eventIdToDelete: -1,
                timelineDataEvents: [],
                allDataHistory: {
                    data: [],
                    total: 0,
                    from: null,
                    to: null,
                },
                dataResponse: {
                    events:[],
                    projects:[],
                    cashingEvents:[]
                },
                requestMade: false,
            }
        },
        computed:{
            eventsFiltered () {
                return this.eventsToShow;
            },
            allEventsProjectHistory() {
                return this.allDataHistory.data;
            },
            from() {
                return this.allDataHistory.from;
            },
            to() {
                return this.allDataHistory.to;
            },
            totalRecords() {
                return this.allDataHistory.total;
            }
        },
        watch: {
            selectedProjectEventHistory: function(){
                this.numberSearchPage = 1;
                this.getAllEventsForProject();
            }
        },
        methods: {
            async getEvents(){
                this.resetValues();
                this.showLoading(true);
                this.requestMade = false;
                await axios.post('/api/cobranza/projectCashingEventsList',{ client_id: this.clientId }).then(response => {
                    this.dataResponse = response.data;
                    this.setProjectsForCheckBoxes();
                    if (this.dataResponse.projects.length > 0) {
                        this.selectedProject = this.dataResponse.projects[0].project_id;
                    }
                    // this.eventsToShow = this.dataResponse.projectEvents.filter(p => p.project_id === this.selectedProject);
                    this.requestMade = true;
                }).catch(error => {
                    this.requestMade = false;
                    if(error.response.data.message !== undefined){
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    }else{
                        this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
                    }
                });
                this.setEvents();
                this.requestMade = true;
                this.showLoading(false);
            },
            async getAllEventsForProject(url = `/api/cobranza/allCashingEventsForProject/${this.selectedProjectEventHistory}?page=${this.numberSearchPage}`){
                this.showLoading(true);
                await axios.get(url).then(response => {
                    this.allDataHistory = response.data;
                }).catch(error => {
                    if(error.response.data.message !== undefined){
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    }else{
                        this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
                    }
                });
                this.showLoading(false);
            },
            confirmDeleteProjectEvent(id){
                this.eventIdToDelete = id;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Aviso`,
                    text: '¿Estas seguro de querer eliminar el evento para el proyecto seleccionado?',
                    acceptText: "Confirmar",
                    cancelText: "Cancelar",
                    accept: this.deleteEvent
                })
            },
            async deleteEvent(){
                this.showLoading(true);
                await axios.post('/api/cobranza/postProjectCashingEvent', {
                    project_id: this.selectedProject,
                    project_event_id: this.eventIdToDelete,
                    action: "delete"
                }).then(response => {
                    this.resetValues();
                    this.dataResponse = response.data;
                    this.eventsToShow = this.dataResponse.projectEvents.filter(p => p.project_id === this.selectedProject);
                    this.successNotif("Aviso", 'Evento eliminado exitosamente', 4000);
                    this.setEvents();
                }).catch(error => {
                    this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
                })
                this.showLoading(false);
            },
            setProjectsForCheckBoxes(){
                this.projectsSelected = [];
                Object.keys(this.dataResponse.projects).forEach(key => {
                    const project = this.dataResponse.projects[key];
                    this.projectsSelected.push(project.project_id);  
                })
            },
            setEvents(){
                if (this.selectedProject) {
                    this.selectedProjectEventHistory = this.selectedProject;
                    this.getAllEventsForProject();
                }
                // this.timelineDataEvents = [];
                // Object.keys(this.eventsFiltered).forEach(key => {
                //     const event = this.eventsFiltered[key];
                //     this.timelineDataEvents.push(event);  
                // })
            },
            async pager() {
                await this.getAllEventsForProject();
            },
            // setProjectSelected() {
            //     this.eventsToShow = this.dataResponse.projectEvents.filter(p => p.project_id === this.selectedProject);
            //     this.setEvents();                 
            // },
            resetValues(){
                this.numberSearchPage = 1;
                this.allDataHistory.data = [];
                this.allDataHistory.total = 0;
                this.allDataHistory.from = null;
                this.allDataHistory.to = null;
                this.eventIdToDelete = -1;
            }
        }
    }
</script>